import * as actionTypes from "../ActionTypes";

const initialState = {
  // Comment CRUD operations
  creating: false,
  updating: false,
  deleting: false,
  reading: false,
  error: null,
  
  // Comments data
  comments: [],
  commentsPagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  
  // Comment tree
  commentTree: null,
  fetchingTree: false,
  treeError: null,
  
  // Likes
  liking: false,
  unliking: false,
  likesError: null,
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    // CREATE COMMENT
    case actionTypes.COMMENT_CREATE_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };
    
    case actionTypes.COMMENT_CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        // Optionally add the new comment to the list
        comments: action.payload?.comment ? 
          [action.payload.comment, ...state.comments] : 
          state.comments,
      };
    
    case actionTypes.COMMENT_CREATE_FAIL:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };
    
    // UPDATE COMMENT
    case actionTypes.COMMENT_UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };
    
    case actionTypes.COMMENT_UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        // Update comment in the list
        comments: state.comments.map(comment => 
          comment._id === action.payload?.comment?._id ? 
          action.payload.comment : comment
        ),
      };
    
    case actionTypes.COMMENT_UPDATE_FAIL:
      return {
        ...state,
        updating: false,
        error: action.payload,
      };
    
    // DELETE COMMENT
    case actionTypes.COMMENT_DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };
    
    case actionTypes.COMMENT_DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        // Remove comment from the list
        comments: state.comments.filter(
          comment => comment._id !== action.payload?.commentObjId
        ),
      };
    
    case actionTypes.COMMENT_DELETE_FAIL:
      return {
        ...state,
        deleting: false,
        error: action.payload,
      };
    
    // READ COMMENTS
    case actionTypes.COMMENT_READ_REQUEST:
      return {
        ...state,
        reading: true,
        error: null,
      };
    
    case actionTypes.COMMENT_READ_SUCCESS:
      return {
        ...state,
        reading: false,
        comments: action.payload.data || [],
        commentsPagination: action.payload.pagination || {
          page: 1,
          limit: 10,
          total: 0,
        },
      };
    
    case actionTypes.COMMENT_READ_FAIL:
      return {
        ...state,
        reading: false,
        error: action.payload,
      };
    
    // COMMENT TREE
    case actionTypes.COMMENT_TREE_REQUEST:
      return {
        ...state,
        fetchingTree: true,
        treeError: null,
      };
    
    case actionTypes.COMMENT_TREE_SUCCESS:
      return {
        ...state,
        fetchingTree: false,
        commentTree: action.payload,
      };
    
    case actionTypes.COMMENT_TREE_FAIL:
      return {
        ...state,
        fetchingTree: false,
        treeError: action.payload,
      };
    
    // SAVE LIKE
    case actionTypes.COMMENT_LIKE_SAVE_REQUEST:
      return {
        ...state,
        liking: true,
        likesError: null,
      };
    
    case actionTypes.COMMENT_LIKE_SAVE_SUCCESS:
      return {
        ...state,
        liking: false,
        // Update likes count in comments
        comments: state.comments.map(comment => 
          comment._id === action.payload?.commentObjId ? 
          { 
            ...comment, 
            likesCount: (comment.likesCount || 0) + 1,
            userLiked: true,
            userLikeId: action.payload?.likeId 
          } : 
          comment
        ),
        // Update comment tree if exists
        commentTree: state.commentTree && state.commentTree._id === action.payload?.commentObjId ? 
          { 
            ...state.commentTree, 
            likesCount: (state.commentTree.likesCount || 0) + 1,
            userLiked: true,
            userLikeId: action.payload?.likeId 
          } : 
          state.commentTree,
      };
    
    case actionTypes.COMMENT_LIKE_SAVE_FAIL:
      return {
        ...state,
        liking: false,
        likesError: action.payload,
      };
    
    // DELETE LIKE
    case actionTypes.COMMENT_LIKE_DELETE_REQUEST:
      return {
        ...state,
        unliking: true,
        likesError: null,
      };
    
    case actionTypes.COMMENT_LIKE_DELETE_SUCCESS:
      return {
        ...state,
        unliking: false,
        // Update likes count in comments
        comments: state.comments.map(comment => 
          comment._id === action.payload?.commentObjId ? 
          { 
            ...comment, 
            likesCount: Math.max(0, (comment.likesCount || 0) - 1),
            userLiked: false,
            userLikeId: null
          } : 
          comment
        ),
        // Update comment tree if exists
        commentTree: state.commentTree && state.commentTree._id === action.payload?.commentObjId ? 
          { 
            ...state.commentTree, 
            likesCount: Math.max(0, (state.commentTree.likesCount || 0) - 1),
            userLiked: false,
            userLikeId: null
          } : 
          state.commentTree,
      };
    
    case actionTypes.COMMENT_LIKE_DELETE_FAIL:
      return {
        ...state,
        unliking: false,
        likesError: action.payload,
      };
    
    default:
      return state;
  }
};

export default commentReducer;